import { useState } from "react";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid2";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import styles from "./BlogContent.module.scss";
import { Author, SocialShare } from "../../../library/common";

const BlogContent = ({
  socialMediaLinks,
  tags = [],
  title,
  relateds = [],
  longDescription = "",
}) => {
  const {
    i18n: { language },
  } = useTranslation();
  const [focusedCardIndex, setFocusedCardIndex] = useState(null);

  const handleFocus = (index) => {
    setFocusedCardIndex(index);
  };

  const handleBlur = () => {
    setFocusedCardIndex(null);
  };

  return (
    <div className={styles.contentContainerWrapper}>
      <div className={styles.contentContainer}>
        <div className="ql-editor">
          <div
            className={styles.contentContainerTag}
            dangerouslySetInnerHTML={{
              __html: longDescription?.[language] || "",
            }}
          />
        </div>
        {tags?.length > 0 && (
          <ul className={styles.tagContainer}>
            {tags.map((n, i) => (
              <li key={i}>#{n}</li>
            ))}
          </ul>
        )}

        {relateds?.length > 0 && (
          <div className={styles.relatedsContainer}>
            <Typography
              gutterBottom
              variant="h2"
              component="h2"
              className={styles.headingh2}
            >
              Relateds
            </Typography>
            <Grid container spacing={5} columns={8}>
              {relateds.map((post, index) => (
                <Grid
                  key={index}
                  size={{ xs: 12, md: index < 2 ? 2 : 2 }}
                  className={styles.cardGrid}
                >
                  <Card
                    variant="outlined"
                    onFocus={() => handleFocus(index)}
                    onBlur={handleBlur}
                    tabIndex={0}
                    className={`${styles.styledCard} ${
                      focusedCardIndex === index ? styles.focusedCard : ""
                    }`}
                  >
                    <CardMedia
                      component="img"
                      alt="Blog post image"
                      image={post.coverImg}
                      className={styles.cardMedia}
                      loading="lazy"
                    />
                    <CardContent className={styles.cardContent}>
                      <Typography
                        gutterBottom
                        variant="caption"
                        component="div"
                      >
                        {(post?.metafields.tags?.length
                          ? post?.metafields.tags
                          : []
                        ).join(", ")}
                      </Typography>
                      <Typography
                        gutterBottom
                        variant="h6"
                        component="div"
                        className={styles.cardTitle}
                      >
                        {post?.title?.[language] || ""}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        gutterBottom
                        className={styles.cardDescription}
                      >
                        {post?.shortDescription?.[language] || ""}
                      </Typography>
                    </CardContent>
                    <Author author={post.authors?.[0]} />
                  </Card>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
      </div>
      <SocialShare
        socialMediaLinks={socialMediaLinks}
        wrapperClass={styles.contentShareContainer}
        title={title?.[language] || ""}
      />
    </div>
  );
};

export default BlogContent;
